// import getCropped from './getCroppedUpload';

export default {
  handleValidations(i, result) {
    if (result[`${i.name}`] === '') {
      this.errorValidateForm(i);
    }
  },

  errorValidateForm(i) {
    const border = document.getElementById(`load-${i.name}`);
    border.style.border = '1px dashed #FF4848';
    document.getElementById(`error-${i.name}`).style.display = 'block';
  },

  /**
   * @param {*} param0.blob (blob)
   * @param {*} param0.validSize (string in mb)
   */

  validateSize(blob, validSize) {
    const blobSize = blob.size / 1024 / 1024;
    if (blobSize <= Number(validSize)) {
      return true;
    }

    return false;
  }
};
